module.exports = __webpack_public_path__ + "img/menu.b8bb3e9b.svg";